import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAnimation } from 'hooks/useAnimation';
import { selectCurrentLocations, selectLocations } from 'store/slices/LocationsSlice';
import { ReactComponent as WorldMap } from 'assets/mapilustration.svg';
import { useNavigate } from 'react-router-dom';

import './styles.scss';
import ROUTES from 'constants/routes';
import { getImageUrl } from 'helpers';

const CurrentLocationWorldMap = ({ isLoading }) => {
    const data = useSelector(selectCurrentLocations);
    const locations = useSelector(selectLocations);
    const container = useRef();
    const map = useRef();
    const markerRef = useRef();


    const navigate = useNavigate();
    const [hoveredData, setHoveredData] = useState(null);

    useAnimation({
        items: ['.location-map'],
        container,
        dependencies: [isLoading],
    });



    const handleCountryHover = (event) => {
        const target = event.target;

        if (target.tagName.toLowerCase() === 'svg') {
            setHoveredData(null);
            return;
        }

        const pathId = target.id;
        let hoveredElementId = pathId;

        if (!hoveredElementId && target.parentNode && target.parentNode.id) {
            hoveredElementId = target.parentNode.id;
        }

        const matchingData = locations.find(item => item.attributes.country_code.toLowerCase() === hoveredElementId);

        if (matchingData) {
            setHoveredData(matchingData);
        } else {
            setHoveredData(null);
        }
    };

    const handleCountryLeave = () => {
        setHoveredData(null);
    };

    const handleCountryClick = () => {

        if (hoveredData) {
            navigate(`${ROUTES.location}/${hoveredData.attributes.slug}`);
        }
    };
    const applyRedFillToElement = (elementId) => {
        if (elementId) {
            const lowerCaseElementId = elementId.toLowerCase();
            // @ts-ignore
            const element = map.current.querySelector(`#${lowerCaseElementId}`);
            // @ts-ignore
            const selectedElements = map.current.querySelectorAll('.selected');
            selectedElements.forEach(element => {
                element.classList.remove('selected');
            });

            if (element) {
                if (element.tagName.toLowerCase() === 'g') {
                    const paths = element.querySelectorAll('path');
                    paths.forEach(path => {
                        path.classList.add('available');
                    });
                } else if (element.tagName.toLowerCase() === 'path') {
                    element.classList.add('available');
                }
            }
        }
    };


    const handleCountryChange = (country_code) => {
        const code = String(country_code).toLowerCase();
        const map = document.getElementById('map');
        const svg = document.getElementById('location-mask');
        const parentPos = svg.getBoundingClientRect();
        let child = map.querySelector(`#${code}`);


        const mainlandPath = child.querySelector('path.mainland');
        if (mainlandPath) {
            child = mainlandPath
        }

        const bbox = child.getBBox();

        const baseScale = Math.min(
            parentPos.width / bbox.width,
            parentPos.height / bbox.height
        );

        const minScale = 1.6;
        const scaleFactor = parentPos.width <= 650 ? 0.4 : 0.2;

        let adjustedScale = Math.max(baseScale * scaleFactor, minScale);

        const centerX = bbox.x + bbox.width / 2;
        const centerY = bbox.y + bbox.height / 2;

        let translateX;
        let translateY;
        if (parentPos.width < 663) {
            translateX = (parentPos.width / 2) - (centerX * adjustedScale) + (663 - parentPos.width) / 2;
            translateY = (parentPos.height / 2) - (centerY * adjustedScale) + (624 - parentPos.height) / 2;
        } else {
            translateX = (parentPos.width / 2) - (centerX * adjustedScale);
            translateY = (parentPos.height / 2) - (centerY * adjustedScale);
        }

        const marker = markerRef.current;
        if (parentPos.width < 663) {
            // marker.style.left = `${translateX + (centerX * adjustedScale) - (663 - parentPos.width) / 2}px`;
            // marker.style.top = `${translateY + (centerY * adjustedScale) - bbox.height / 2 - (624 - parentPos.height) / 2}px`;
            marker.style.left = `${translateX + (centerX * adjustedScale) - (663 - parentPos.width) / 2}px`;
            marker.style.top = `${translateY + (centerY * adjustedScale) - (624 - parentPos.height) / 2}px`;
        } else {
            marker.style.left = `${translateX + (centerX * adjustedScale)}px`;
            marker.style.top = `${translateY + (centerY * adjustedScale)}px`;
        }


        map.setAttribute('style', `transform: translate(${translateX}px, ${translateY}px) scale(${adjustedScale}); transform-origin: 0 0;`);
    };


    const applySelectedCountry = (elementId) => {
        if (elementId) {
            const lowerCaseElementId = elementId.toLowerCase();
            // @ts-ignore
            const element = map.current.querySelector(`#${lowerCaseElementId}`);

            if (element) {
                if (element.tagName.toLowerCase() === 'g') {
                    const paths = element.querySelectorAll('path');
                    paths.forEach(path => {
                        path.classList.add('selected');
                    });
                } else if (element.tagName.toLowerCase() === 'path') {
                    element.classList.add('selected');
                }
            }
        }
    };

    useEffect(() => {
        locations?.forEach(item => {
            applyRedFillToElement(item.attributes.country_code);
        });
        if (data?.country_code) {
            applySelectedCountry(data?.country_code)
            handleCountryChange(data?.country_code)
        }
    }, [locations, data?.country_code]);
    if (!locations) return

    return (
        <div ref={container} className="current-map-container">
            <div ref={markerRef} className='current-location-map-marker'>
                <div className='current-location-map-marker__image'>
                    <img src={getImageUrl(data?.flag)} alt={data?.name} />
                </div>
            </div>

            <div className={`current-location-map ${hoveredData ? "current-location-map--find-element" : ""} `} onMouseMove={handleCountryHover} onMouseLeave={handleCountryLeave} onClick={handleCountryClick}>
                <WorldMap ref={map} />
            </div>
        </div>
    );
};

export default CurrentLocationWorldMap;
